export default __webpack_public_path__ + "static/media/bg.e7a55bc1.mp4";